import { useQuery } from '@tanstack/react-query'

import { QUERY_KEYS } from 'constants/constants'
import { EVALUATION_CONTEXT } from '../features/discover/utils'
import { query } from '../graphql'

export const useTalentProfileQuery = ({
  spaceId,
  ownerId,
  language,
  ...options
}) => {
  return useQuery({
    queryKey: QUERY_KEYS.talentProfile(spaceId, ownerId, language),
    queryFn: async () => {
      const variables = {
        action: 'generateText',
        space_id: spaceId,
        user_id: ownerId,
        language,
        text_generation_context: EVALUATION_CONTEXT.TALENTPROFILE
      }

      const response = await query({ query: 'helperControl', variables })
      if (!response || response === 'undefined') {
        console.error('TALENTPROFILE: Invalid response received:', response)
        throw new Error('Invalid response from helperControl query')
      }

      try {
        const parsed = JSON.parse(response)
        if (!parsed?.body?.generateText?.res) {
          console.error('TALENTPROFILE: Invalid response structure:', parsed)
          throw new Error('Invalid response structure from helperControl')
        }
        return parsed.body.generateText.res
      } catch (error) {
        console.error('TALENTPROFILE: Error parsing response:', error)
        throw new Error('Error parsing response from helperControl')
      }
    },
    ...options
  })
}
